
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 17 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M6.313 21.812a2.772 2.772 0 004.84 0c2.346-4.052 5.553-10.13 5.553-13.07 0-4.638-3.57-8.396-7.973-8.396C4.329.346.76 4.104.76 8.74c0 2.941 3.207 9.019 5.553 13.07zm2.42-8.873c2.202 0 3.986-1.88 3.986-4.198 0-2.318-1.784-4.198-3.986-4.198s-3.987 1.88-3.987 4.198c0 2.318 1.785 4.198 3.987 4.198z","fill":"#9FA6BC"}})])
          )
        }
      }
    